const subsidyProgramIsOpen = (subsidyProgram) => {
  if (!subsidyProgram) return false;

  if (subsidyProgram.opens_at && new Date() < new Date(subsidyProgram.opens_at)) return false;

  if (subsidyProgram.closes_at && new Date() > new Date(subsidyProgram.closes_at)) return false;

  return true;
};

export { subsidyProgramIsOpen };
